// extracted by mini-css-extract-plugin
export default {"container":"loa-z","creativeContainer":"moa-z","copy":"noa-z","cta":"ooa-z","disabled":"poa-z","flipped":"qoa-z","productCard":"roa-z"};